import icons from './icons';

const assets = {
  icons,
};

export default assets;
